<template>
  <div>
    <div v-if="mode === 'DESIGN'">
      <el-button size="small" icon="el-icon-paperclip" round>选择文件</el-button>
      <ellipsis :row="1" :content="placeholder + sizeTip" hoverTip slot="tip" class="el-upload__tip"/>
    </div>
    <div v-else>
      <el-upload
          multiple
          accept=".doc,.docx,.xls,.xlsx,.pdf,.ppt"
          :file-list="_value"
          :action="uploadFileUrl"
          :limit="maxSize"
          :multiple="maxSize > 0"
          :on-success="handleUploadSuccess"
          :before-upload="beforeUpload"
          :headers="headers"
          :data="uploadParams"
          :show-file-list="false"
      >
        <!-- with-credentials -->
        <!-- :auto-upload="false" -->
        <el-button size="small" icon="el-icon-paperclip" round :disabled="r">选择文件</el-button>
        <!-- 上传提示 -->
        <div class="el-upload__tip" slot="tip">
          请上传
          <template v-if="maxSize">
            大小不超过<b style="color: #f56c6c">{{ maxSize }}MB</b>
          </template>
          <template v-if="fileType">
            格式为 <b style="color: #f56c6c">{{ fileType.join('/') }}</b>
          </template>
          的文件
        </div>
        <!-- <ellipsis
          :row="1"
          :content="placeholder + sizeTip"
          hoverTip
          slot="tip"
          class="el-upload__tip"
        /> -->
      </el-upload>

      <!-- 文件列表 -->
      <transition-group class="upload-file-list el-upload-list el-upload-list--text" name="el-fade-in-linear" tag="ul">
        <li :key="file.url" class="el-upload-list__item ele-upload-list__item-content" v-for="(file, index) in _value">
          <!-- :href="`${file.url}`"
            target="_blank" -->
          <el-link :underline="false" @click="go(file.url)">
            <span class="el-icon-document"> {{ getFileName(file.name) }} </span>
          </el-link>
          <!-- <el-tooltip
            v-else
            class="item"
            effect="dark"
            content="点击下载"
            placement="top"
          >
            <el-link :href="`${file.url}`" :underline="false" target="_blank">
              <span class="el-icon-document">
                {{ getFileName(file.name) }}
              </span>
            </el-link>
          </el-tooltip> -->

          <div class="ele-upload-list__item-content-action" style="margin-left: 5px" v-if="isShowDel">
            <el-link :underline="false" @click="handleDelete(index)" style="width: 50px" type="danger">删除</el-link>
          </div>
        </li>
      </transition-group>
    </div>
  </div>
</template>

<script>
import {getToken} from '@/utils/auth'
import componentMinxins from '../ComponentMinxins'
import config from '@/config/index'

export default {
  mixins: [componentMinxins],
  name: 'ImageUpload',
  components: {},
  props: {
    placeholder: {
      type: String,
      default: '请选择附件',
    },
    value: {
      type: Array,
      default: () => {
        return []
      },
    },
    maxSize: {
      type: Number,
      default: 5,
    },
    maxNumber: {
      type: Number,
      default: 10,
    },
    fileTypes: {
      type: Array,
      default: () => ['doc', 'docx', 'xls', 'ppt', 'xlsx', 'pdf'],
    },
    config1: {
      type: Object,
      default: () => {
        return {}
      },
    },
    // 是否显示删除
    isShowDel: {
      type: Boolean,
      default: true,
    },
  },
  mounted() {
    this.fileType = ['doc', 'docx', 'xls', 'ppt', 'xlsx', 'pdf']
    console.log(this.maxSize, 'this.maxSize.maxSize.maxSize')
    setTimeout(() => {
      if (this.config1) {
        console.log(this.config1, '文件上传')
        this._value = this.config1.value || [] // 初始化 fileList
        if (this.config1.flag == 2 || this.config1.flag == 3 || this.config1.flag == 4) {
          console.log('仅可读仅可读')
          this.r = true
          this.isShowDel = false
        } else {
          var perm = this.config1.perm
          if (perm == 'R') {
            this.r = true
          }
        }
      }
    }, 500)
  },
  computed: {
    _value: {
      get() {
        return this.fileList
      },
      set(value) {
        this.fileList = value
      }
    },
    sizeTip() {
      if (this.fileTypes.length > 0) {
        return ` | 只允许上传[${String(this.fileTypes).replaceAll(',', '、')}]格式的文件，且单个附件不超过${
            this.maxSize
        }MB`
      }
      return this.maxSize > 0 ? ` | 单个附件不超过${this.maxSize}MB` : ''
    },
  },
  data() {
    return {
      loading:'',
      headers: {
        Authorization: 'Bearer ' + getToken(),
      },
      disabled: false,
      uploadParams: {},
      fileList: this.value || [], // 初始化时从 value prop 获取文件列表
      fileType: [],
      r: false,
      uploadFileUrl: config.apiUploadUrl, // 上传文件服务器地址
    }
  },
  methods: {
    go(url) {
      if (window.__wxjs_environment === 'miniprogram') {
        // 页面 不会重新加载
        window.wx.miniProgram.navigateTo({
          url: '../public/downLoading?url=' + url,
        })
        // }, 100);
      } else {
        // alert("请在微信小程序中打开");
        window.open(url, '_blank')
        // 页面会 重新加载(如:列表页 查看详情后会返回顶部)
        // this.$router.push(path);
      }
    },
    // 获取文件名称
    getFileName(name) {
      if (name.lastIndexOf('/') > -1) {
        return name.slice(name.lastIndexOf('/') + 1)
      } else {
        return ''
      }
    },
    // 上传成功回调
    handleUploadSuccess(response, file, fileList) {
      if (fileList.every(item => item.status == 'success')) {
        fileList.map(item => {
          /** 这时只需要push进带有response的数据就好 */
          if(item.response) {
            // this.imagePreviewUrls.push(item.response.data) // 预览图片的数组
            this.fileList.push({
              name: item.response.data,
              url: item.response.data
            })
            this._value = this.fileList
            this.$emit('input', this._value)
          }
        })
        this.loading.close();// 开始上传时设置加载状态为true
      }
      // if (res.code === 200) {
      //   // 将新上传的文件添加到现有的文件列表中
      //   this.fileList.push({name: res.data, url: res.data})
      //   this._value = this.fileList
      //   console.log(this._value, 'this._value')
      //   // 触发 input 事件，更新父组件的 value prop
      //   this.$emit('input', this._value)
      // } else {
      //   this.$message.error('文件上传失败')
      // }
    },
    beforeUpload(file, fileList) {
      // 校检文件类型
      if (this.fileType) {
        console.log(this.fileType, 'this.fileType')
        const fileName = file.name.split('.')
        const fileExt = fileName[fileName.length - 1]
        const isTypeOk = this.fileType.indexOf(fileExt) >= 0
        if (!isTypeOk) {
          this.$message.warning(`文件格式不正确, 请上传${this.fileType.join('/')}格式文件!`)
          // this.$modal.msgError(

          // );
          return false
        }
      }
      // 校检文件大小
      if (this.maxSize) {
        const isLt = file.size / 1024 / 1024 < this.maxSize
        if (!isLt) {
          this.$message.error(`上传文件大小不能超过 ${this.maxSize} MB!`)
          return false
        }
      }
      // this.uploading = true; // 开始上传时设置加载状态为true

       this.loading = this.$loading({
        lock: true,
        text: '文件导入中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });

    },
    // 删除文件
    handleDelete(index) {
      console.log(index, 'index')
      this.fileList.splice(index, 1)
      this._value = this.fileList
      this.$emit('input', this.listToString(this._value))
    },
    // 对象转成指定字符串分隔
    listToString(list, separator) {
      console.log(list)
      console.log(separator)
      var strs = ''
      var arr = []
      list.forEach((i) => {
        arr.push(i.url)
      })
      strs = arr.join(',')

      return strs != '' ? strs.substr(0, strs.length) : ''
    },
    handlePictureCardPreview(file) {
      console.log(file)
    },
    handleDownload(file) {
      console.log(file)
    },
  },
}
</script>

<style lang="less" scoped>
.upload-义马市智慧养老服务平台er {
  margin-bottom: 5px;
}

.upload-file-list .el-upload-list__item {
  // border: 1px solid #e4e7ed;
  line-height: 2;
  // margin-bottom: 10px;
  position: relative;
}

.upload-file-list .ele-upload-list__item-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: inherit;
}

.ele-upload-list__item-content-action .el-link {
  margin-right: 10px;
}

.el-icon-document {
  width: 260px;
  display: -webkit-box;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  white-space: nowrap;
}

</style>
